// src/utils/crypto.js
import CryptoJS from 'crypto-js'


const _p1 = 'opOpKkKkiKSIiskwotjskadn^';
const _p2 = '2ialdsasd';
const SECRET_KEY = _p1 + _p2;

export function decryptAES (encryptedBase64) {
  if (!encryptedBase64) return '';
  try {

    const key = CryptoJS.SHA256(SECRET_KEY);
    const raw = atob(encryptedBase64);
    if (raw.length < 16) return '';
    const iv = CryptoJS.enc.Latin1.parse(raw.slice(0, 16));
    const ciphertext = CryptoJS.enc.Latin1.parse(raw.slice(16));
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertext },
      key,
      { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {

    return '';
  }
}